import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import DataSourceCharacteristicsDto from "../classes/dtos/datasourcemodule/DataSourceCharacteristicsDto";

const DataSourceCharacteristicsApi = {

    GetDataSourceCharacteristicsByIdAsync: async function (id: number): Promise<ProcessingResult<DataSourceCharacteristicsDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/DataSourceCharacteristics/GetDataSourceCharacteristicsById?dataSourceId=" + id, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();

            return ProcessingResult.Ok(new DataSourceCharacteristicsDto(data.viewsLinkedToTables, data.readSchemaAvailable, data.createSchemaAvailable, data.updateSchemaAvailable, data.readAvailable, data.createAvailable, data.updateAvailable, data.deleteAvailable));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default DataSourceCharacteristicsApi;